import * as React from 'react';
import { SearchResults } from '../model/searchresultModel';
import { v4 as uuidv4 } from "uuid";

interface ArticleSearchResultsModel {
    result: SearchResults,
}

const ArticleSearchResults: React.FC<ArticleSearchResultsModel> = (props) => {
    return (
        <ul className="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 gap-y-7 gap-x-5">
            {props.result.articleSearchResult.pages.map((article) => {
                return (
                    <li key={uuidv4()} className="rounded-lg relative group focus-within:outline-[3px] focus-within:outline-red-secondary">
                        {article.media !== null && (
                            <figure className="overflow-hidden rounded-xl mb-3 aspect-[3/2] bg-orange-25 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWltYWdlLWljb24gbHVjaWRlLWltYWdlIj48cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiByeT0iMiIvPjxjaXJjbGUgY3g9IjkiIGN5PSI5IiByPSIyIi8+PHBhdGggZD0ibTIxIDE1LTMuMDg2LTMuMDg2YTIgMiAwIDAgMC0yLjgyOCAwTDYgMjEiLz48L3N2Zz4=')] bg-center bg-no-repeat">
                                <picture>
                                    <source media="(min-width: 1280px)" srcSet={`${article.media.url}__w=169_h=180__autocrop=true`} />
                                    <source media="(min-width: 1024px)" srcSet={`${article.media.url}__w=205_h=137__autocrop=true`} />
                                    <source media="(min-width: 768px)" srcSet={`${article.media.url}__w=346_h=230__autocrop=true`} />
                                    <img loading="lazy" src={`${article.media.url}__w=735_h=490__autocrop=true`} alt={article.media.description} className="transition-all group-hover:scale-110 group-active:scale-105 w-full"/>
                                </picture>
                            </figure>
                        )}
                        {article.media === null && (
                            <div className="rounded-xl mb-3 aspect-[3/2] bg-orange-25 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWltYWdlLWljb24gbHVjaWRlLWltYWdlIj48cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHg9IjMiIHk9IjMiIHJ4PSIyIiByeT0iMiIvPjxjaXJjbGUgY3g9IjkiIGN5PSI5IiByPSIyIi8+PHBhdGggZD0ibTIxIDE1LTMuMDg2LTMuMDg2YTIgMiAwIDAgMC0yLjgyOCAwTDYgMjEiLz48L3N2Zz4=')] bg-center bg-no-repeat"></div>
                        )}

                        {article.tags.length > 0 && (
                            <ul className='flex flex-wrap gap-3 mb-3'>
                                {article.tags.map(tag => (
                                    <li key={uuidv4()} className='px-4 py-1 rounded-5xl bg-yellow-primary text-base'>
                                        {tag.tagName}
                                    </li>
                                ))}
                            </ul>
                        )}

                        <h3 className='font-semibold text-xl laptop:text-2xl leading-7 mb-1.5 laptop:leading-8 laptop:mb-2'>
                            {article.pageTitle}
                        </h3>
                        
                        <p className="line-clamp-2">
                            {article.ingress}
                        </p>

                        <a href={article.url} title={article.pageTitle} className='absolute inset-0 focus-visible:outline-2 outline-offset-4 outline-red-secondary rounded-lg'>
                            <span className="sr-only">{article.pageTitle}</span>
                        </a>                        
                        
                    </li>
                )
            })}
        </ul>
    );
};

export default ArticleSearchResults;


